import BASE_URL from "../../config";
const menuItems = [
  {
    label: "Home",
    key: "home",
    path: BASE_URL,
  },
  {
    label: "About",
    key: "About",
    path: `${BASE_URL}/about-us`,
  },
  {
    label: "Benefits",
    key: "Benefits",
    path: `${BASE_URL}/benefits`,
  },
  {
    label: "Blog",
    key: "Blog",
    path: `${BASE_URL}/blog`,
  },
  {
    label: "Testimonial",
    key: "testimonial",
    path: `${BASE_URL}/testimonials`,
  },
  {
    label: "Contact Us",
    key: "contact",
    path: `${BASE_URL}/contact-us`,
  },
];

export default menuItems;
